module.exports = __webpack_public_path__ + "static/new_editor_small-dbc839b3075ff0baf111eb0be431b01c.svg";